import React from "react";
import { X } from "lucide-react";
import "./AdvertisingSlots.css";

const BookingModal = ({
  open,
  onClose,
  slot,
  date,
  cardImage,  
  loading,
  onConfirm,
}) => {

  if (!open || !slot) return null;

  return (
    <div className="adv-modal-overlay">
      <div className="adv-modal-container">

        {/* HEADER */}
        <div className="adv-modal-header">
          <h3>Confirm Booking</h3>
          <button className="adv-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* BODY */}
        <div className="adv-modal-body">
          <div className="adv-info-box">
            <p><strong>Time:</strong> {slot.start_time} - {slot.end_time}</p>
            <p><strong>Price:</strong> ₹{slot.price}</p>
            <p><strong>Date:</strong> {date}</p>
          </div>  

 <div className="adv-image-box">
  <label className="adv-image-label">Uploaded Visiting Card</label>

  {cardImage ? (
    <img
      src={cardImage}
      className="adv-card-image"
      alt="Visiting Card"
    />
  ) : (
  <div className="no-img">No Image</div>
       )}
       </div>
        </div>
        {/* FOOTER */}
        <div className="adv-modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Booking..." : "Book Now"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default BookingModal;
